module.exports = __webpack_public_path__ + "static/media/1share-ust.89c220ff.svg";